import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import SubmitJobPostingsPageLayout
  from '@fuww/library/src/Layouts/SubmitJobPostingsPage';
import Button from '@fuww/library/src/Button';
import messages from '../lib/messages';
import Head from '../components/Head';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import LinkAndAnchor from '../components/LinkAndAnchor';
import createCompanyBreadcrumbs from '../lib/createCompanyBreadcrumbs';

const headerImageUrls = {
  mobile: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=34,quality=10,width=42/https://media.fashionunited.com/media/images/submit-your-job-postings.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=288,quality=70,width=360/https://media.fashionunited.com/media/images/submit-your-job-postings.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=576,quality=70,width=720/https://media.fashionunited.com/media/images/submit-your-job-postings.jpg',
  ],
  desktop: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=8,quality=10,width=42/https://media.fashionunited.com/media/images/submit-your-job-postings.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=277,quality=70,width=1350/https://media.fashionunited.com/media/images/submit-your-job-postings.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=526,quality=70,width=2560/https://media.fashionunited.com/media/images/submit-your-job-postings.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=1052,quality=70,width=5120/https://media.fashionunited.com/media/images/submit-your-job-postings.jpg',
  ],
};

const SubmitJobPostingsPage = () => {
  const intl = useIntl();

  const breadcrumbs = createCompanyBreadcrumbs({
    intl,
    crumbRoute: 'submit-job-postings',
    crumbLabel: intl.formatMessage(messages['submitJobPostings.header']),
  });

  return (
    <>
      <Head
        title={intl.formatMessage(messages['submitJobPostings.header'])}
        description=""
      />
      <SubmitJobPostingsPageLayout
        bodyText={(
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              // eslint-disable-next-line max-len
              __html: intl.formatMessage(messages['submitJobPostings.bodyText']),
            }}
          />
        )}
        breadcrumbs={breadcrumbs}
        button={(
          <LinkAndAnchor
            href="https://dashboard.fashionunited.com/jobs/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant="contained">
              {intl.formatMessage(messages['submitJobPostings.buttonLabel'])}
            </Button>
          </LinkAndAnchor>
        )}
        callToActionText={(
          <div
          // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
            // eslint-disable-next-line max-len
              __html: intl.formatMessage(messages['submitJobPostings.callToActionText']),
            }}
          />
        )}
        description={intl.formatMessage(
          messages['submitJobPostings.description'],
        )}
        title="Submit your Job Postings"
      />
    </>
  );
};

SubmitJobPostingsPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Submit job postings banner image"
        imageUrls={headerImageUrls}
      />
    )}
  >
    {page}
  </Layout>
);

export default SubmitJobPostingsPage;
